import React, { Component, ChangeEvent, ReactNode } from 'react';

import Option from './Option';
import './Select.css';

interface Props {
  className: string,
  selected: string,
  options: Array<Option>,
  onChange: (value: string) => void
}

export default class Select extends Component<Props, {selected: string}> {
  private currentClass = 'dino-select';

  onChange: (value: string) => void;

  constructor(props: Props) {
    super(props);
    const { selected, onChange } = this.props;
    this.state = {
      selected,
    };
    // Эта привязка обязательна для работы `this` в колбэке.
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.onChange = onChange;
  }

  handleOptionClick(ev: ChangeEvent<HTMLSelectElement>): void {
    const { selected } = this.state;
    let newValue = ev.currentTarget.value;
    if (!newValue) newValue = selected;

    if (newValue !== selected) {
      this.setState({
        selected: newValue,
      });
      this.onChange(newValue);
    }
  }

  private optionValueByKey(key: string): string | undefined {
    const { options } = this.props;
    const filteredOptions = options.filter((o) => o.key === key)
    if (filteredOptions.length !== 0) {
      return filteredOptions[0].value;
    } else {
      return undefined
    }
  }

  render(): ReactNode {
    const { selected } = this.state;
    const { className, options } = this.props;
    const optionViews = options.map((o: Option) => (
      <option
        key={ `option-view-${o.value}` }
        value={ o.key }
        className={ `${this.currentClass}-option-view` }>
          { o.value }
      </option>
    ));

    return (
      <div className={ `${className} ${this.currentClass}` }>
        <select value={ selected } onChange={ this.handleOptionClick }>
          { optionViews }
        </select>
        <div className="selected">
          { this.optionValueByKey(selected) }
        </div>
      </div>
    );
  }
}
